import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {deleteRateCardApi, getAllRateCardsApi, postRateCardApi, updateRateCardApi} from "../../api/backendAPIs";

export const fetchAllRateCards = createAsyncThunk('fetchAllRateCards', async () => {
    return await getAllRateCardsApi()
})

export const deleteRateCardById = createAsyncThunk('deleteRateCardById', async (payload) => {
    return deleteRateCardApi(payload);
})

export const postRateCard = createAsyncThunk('postRateCard', async (payload) => {
    return postRateCardApi(payload);
})

export const updateRateCard = createAsyncThunk('updateRateCard', async (payload) => {
    return updateRateCardApi(payload);
})

const initialState = {
    rateCards: [],
    loadingRateCards: false,
}

export const rateCardsSlice = createSlice({
    name: 'rateCards',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchAllRateCards.pending]: (state) => {
            state.loadingRateCards = true;
        },
        [fetchAllRateCards.fulfilled]: (state, {payload}) => {
            state.loadingRateCards = false;
            state.rateCards = payload.data.content;
        },
        [fetchAllRateCards.rejected]: (state, {payload}) => {
            state.loadingRateCards = false;
        },
        [postRateCard.pending]: (state) => {
            state.loadingRateCards = true;
        },
        [postRateCard.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.rateCards)];
            arr.push(payload.data)
            state.rateCards = arr
            state.loadingRateCards = false;
        },
        [postRateCard.rejected]: (state) => {
            state.loadingRateCards = false;
        },
        [updateRateCard.pending]: (state) => {
            state.loadingRateCards = true;
        },
        [updateRateCard.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.rateCards)]
            const index = arr.findIndex(o => o.id === payload.data.id)
            if (index !== -1) {
                arr[index] = payload.data
                state.rateCards = arr
            }
            state.loadingRateCards = false;
        },
        [updateRateCard.rejected]: (state) => {
            state.loadingRateCards = false;
        },
        [deleteRateCardById.pending]: (state) => {
            state.loadingRateCards = true;
        },
        [deleteRateCardById.fulfilled]: (state, action) => {
            state.loadingRateCards = false;
            // let index = getIndexForService(arr, action.meta.arg)
            // if (index !== -1) {
            //     arr.splice(index, 1)
            // }
            state.rateCards = state.rateCards
        },
        [deleteRateCardById.rejected]: (state) => {
            state.loadingRateCards = false;
        }
    }
});

export const rateCardsReducer = rateCardsSlice.reducer
